<div class="modal-header">
  <h4 class="modal-title text-center">{{ (status === SwapStatus.approval_pending ? "authorise" : "exchange") | translate}}</h4>
  <button type="button" class="btn-close btn-close-white pull-right" aria-label="Close" (click)="closePopup()"></button>
</div>

<div class="modal-body">
  <div class="text-center border-bottom pb-2" *ngIf="isNative && !isWert">
    <img src="./assets/images/{{isBsc ? 'bnb' : 'eth'}}.svg" alt="" class="_iconSm" height="20" >
    <span class="ms-2 color-secondary font-16 fw-semibold">{{isBsc ? 'BNB' : 'ETH'}} {{"balance" | translate }} {{nativeBal}}</span>
  </div>

  <div class="text-center border-bottom pb-2" *ngIf="!isNative && !isWert">
    <img src="./assets/images/usdt.svg" alt="" class="_iconSm" height="20" >
    <span class="ms-2 color-secondary font-16 fw-semibold">USDT {{"balance" | translate }} {{usdtBal}}</span>
  </div>

  <!-- wert div -->
  <div id="wertCont" *ngIf="wertMode"></div>

  <!-- ====== not started ====== -->

  <div class="body-section" *ngIf="status === SwapStatus.not_started && !wertMode">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <label class="d-block color-secondary font-16 fw-bold ">{{"selling" | translate}}</label>
      <div class="btn-group" dropdown *ngIf="isWert" class="text-uppercase ms-2 color-secondary font-16 fw-bold">$</div>

      <div class="btn-group" dropdown *ngIf="!isWert">
        <span dropdownToggle type="button" class="dropdown-toggle amountType small d-flex align-items-center">
          <img src="./assets/images/{{isBsc ? 'bnb' : 'eth'}}.svg" alt="" class="_iconSm" height="20" *ngIf="isNative">
          <img src="./assets/images/usdt.svg" alt="" class="_iconSm" height="20" *ngIf="!isNative">
          <span class="color-secondary text-uppercase ms-2 font-16 fw-bold">{{tokenName}}</span>
          <img src="./assets/images/arrow-down.svg" alt="" class="ps-1" height="8" >
        </span>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
          <li class="p-2 cursor-pointer" role="menuitem" (click)="changeMode(true)">
            <img src="./assets/images/{{isBsc ? 'bnb' : 'eth'}}.svg" class="me-2" height="20" alt=""/>
            <span class="fs-6 fw-bold upper-case">{{isBsc ? 'BNB' : 'ETH'}}</span>
          </li>
          <li class="p-2 cursor-pointer" role="menuitem" (click)="changeMode(false)">
            <img src="./assets/images/usdt.svg" class="me-2" height="20" alt=""/>
            <span class="fs-6 fw-bold upper-case">USDT</span>
          </li>
          </ul>
        </div>
    </div>

    <div class="amountField d-flex align-items-start">
      <div class="flex-grow-1" [ngClass]="{isLowBalance: isLowBalance && !isWert, isHighBalance: !isLowBalance && !isWert }">
        <input #swapIn type="text" appTwoDigitDecimalNumber [noDecimal]="isNative ? 10 : 6" class="text-end form-control text-truncate color-secondary" placeholder="0" [(ngModel)]="swapToken" (ngModelChange)="tokenUpdate.next($event)">

        <div class="lowBalance fs-7 w-100 m-1" *ngIf="!isLowBalance && !isWert">{{"gas_fees" | translate : {gasFees, modeName } }}</div>

        <!-- ------ low balance info ------ -->

        <div class="lowBalanceContainer m-1" *ngIf="isLowBalance && !isWert">
          <div class="lowBalance fs-7 w-100" *ngIf="isNative">{{"low_gas_fees" | translate : {modeName, gasFees } }}</div>
          <div class="lowBalance fs-7 w-100" *ngIf="!isNative" translate>low_usdt</div>
        </div>

      </div>

      <!-- ------ Max Button ---- -->
        <div class="btn max-btn my-1 rounded ms-2 shadow-none" (click)="max()" *ngIf="!isWert">
          <span class="w-100 text-center">{{"max" | translate}}</span>
        </div>
    </div>

    <div class="d-flex align-items-center justify-content-between mt-3 mb-2">
      <label class="d-block color-secondary font-16 fw-bold  ">{{"buying" | translate}}</label>
      <span class="amountType small">
        <span class="text-uppercase ms-2 color-secondary font-16 fw-bold">{{cryptoName}}</span>
      </span>
    </div>

    <div class="amountField">
      <input type="text" appTwoDigitDecimalNumber [noDecimal]="0" class="text-end form-control text-truncate color-secondary" [(ngModel)]="baseToken" min="minAmount"
        (ngModelChange)="tokenUpdate2.next($event)" pattern="\d*" placeholder="0">
    </div>

    <div class="text-start fs-7 mt-1 w-100 text-danger" *ngIf="baseToken && baseToken < minAmount && !isWert">
      {{"min_crypto" | translate : {minAmount, cryptoName} }}
    </div>

    <div class="text-start fs-7 mt-1 w-100 text-danger" *ngIf="baseToken && baseToken >= minAmount && isLowBalance && !isWert">
      {{"swap_error" | translate : {gasFees, modeName, tokenName } }}
    </div>

    <div class="text-center mt-3">
      <button type="button" class="btn btn-md btn-blue text-white w-100 my-1 border-0" [disabled]="isLowBalance && !isWert" (click)="confirm()" translate>buy_now</button>
    </div>
  </div>


  <!-- ====== show loader ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.in_progess && !wertMode">
    <img src="./assets/images/loading.svg" alt="loading" class="statusIcon">
    <div class="fw-normal fw-bold font-16 px-2 my-3 text-uppercase color-secondary  text-center">
      {{"transaction_in_progress" | translate}}
    </div>
    <p class="fs-6 mb-0 color-secondary">{{"transction_info" | translate: {baseToken} }}</p>
  </div>


  <!-- ====== show confirm ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.confirm_pending && !wertMode">
    <img src="./assets/images/loading.svg" alt="loading" class="statusIcon">
    <div class="fw-normal fs-4  fw-bold my-3 text-uppercase color-secondary header-text text-center">{{"confirm" | translate}}</div>
    <p class="fs-6 mb-0 color-secondary">{{"waiting_confirm" | translate : {cryptoName, tokenName } }}</p>
  </div>


  <!-- ====== show pending ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.approval_pending && !wertMode">
    <img src="./assets/images/loading.svg" alt="loading" class="statusIcon">
    <div class="fw-normal fs-4  fw-bold my-3 text-uppercase color-secondary header-text text-center">{{"authorise" | translate}}</div>
    <p class="fs-6 mb-0 color-secondary">{{"waiting_approve" | translate : {cryptoName} }}</p>
  </div>


  <!-- ====== show success/completed ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.complete && !wertMode">
    <img src="./assets/images/popup-icons/success.svg" alt="complete" class="statusIcon mb-4">
    <div class="fw-bold fs-4 my-2 text-uppercase color-secondary header-text text-center">{{"transaction_success" | translate}}</div>
    <p class="fs-6 mb-3 mb-lg-4 color-secondary">{{"transction_info" | translate: {baseToken} }}</p>

    <div class="d-flex align-items-center justify-content-center">
      <div (click)="viewUrl()" class="btn max-btn crypto-btn my-1 w-80">
        <span class="w-100 text-center">{{"view_transaction" | translate}}</span>
      </div>
    </div>

    <div class=" d-flex align-items-center justify-content-center mt-3 px-2">
      <div class="d-flex justify-content-between button-wrapper w-100">
        <div (click)="closePopup('startAgain')" class="cursor-pointer my-1 fw-semibold text-decoration color-gray">
          <span class="w-100 text-center">{{"start_again" | translate: {tokenName} }}</span>
        </div>
        <div (click)="closePopup('Transaction Successful')" class="cursor-pointer my-1 fw-semibold text-decoration color-gray">
          <span class="w-100 text-center">{{"finish" | translate: {tokenName} }}</span>
        </div>
      </div>
    </div>
  </div>


  <!-- ====== show failed ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.failed && !wertMode">
    <img src="./assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon mb-4">
    <div class="fw-bold fs-4 my-2 text-uppercase color-secondary header-text text-center">{{"transaction_failed" | translate}}
    </div>
    <p class="fs-6 mb-3 mb-lg-4 color-secondary">{{"view_transaction_info" | translate}}
    </p>
    <div class="d-flex align-items-center justify-content-center">
      <div (click)="viewUrl()" class="btn max-btn crypto-btn my-1 w-80">
        <span class="w-100 text-center">{{"view_transaction" | translate}}</span>
      </div>
    </div>
    <div class=" d-flex align-items-center justify-content-center mt-3 px-2">
      <div class="d-flex justify-content-between button-wrapper w-100">
        <div (click)="closePopup('startAgain')" class="cursor-pointer my-1 fw-semibold text-decoration color-gray">
          <span class="w-100 text-center">{{"start_again" | translate: {tokenName} }}</span>
        </div>
        <div (click)="closePopup('Transaction Successful')" class="cursor-pointer my-1 fw-semibold text-decoration color-gray">
          <span class="w-100 text-center">{{"finish" | translate: {tokenName} }}</span>
        </div>
      </div>
    </div>
  </div>


  <!-- ====== show rejected ====== -->

  <div class="body-section text-center" *ngIf="status === SwapStatus.rejected && !wertMode">
    <img src="./assets/images/popup-icons/warning.svg" alt="failed" class="statusIcon mb-4">
    <div class="fw-normal fs-4 mb-3 text-uppercase color-secondary header-text py-2 text-center">
      {{"transaction_rejected" | translate}}
    </div>
    <div class=" d-flex align-items-center justify-content-center">
      <div class="d-flex justify-content-between button-wrapper w-100">
        <div (click)="closePopup('startAgain')" class="cursor-pointer my-1 fw-semibold text-decoration color-gray">
          <span class="w-100 text-center">{{"start_again" | translate: {tokenName} }}</span>
        </div>
        <div (click)="closePopup('Transaction Successful')" class="cursor-pointer my-1 fw-semibold text-decoration color-gray">
          <span class="w-100 text-center">{{"finish" | translate: {tokenName} }}</span>
        </div>
      </div>
    </div>
  </div>

</div>
